<template>
  <div class="pageNotFound">
    <img
      class="pageNotFound__background"
      src="@/assets/images/layout/img-404.jpg"
    />
    <img
      class="pageNotFound__logo"
      src="@/assets/images/layout/logo-transparent.png"
    />
    <div class="pageNotFound__form">
      <img
        class="pageNotFound__img"
        src="@/assets/images/layout/image-opacity.png"
      />
      <div>
        <h1>{{ $t('notFound.title') }}</h1>
        <el-button
          type="primary"
          @click="$router.push({ name: 'records-grid' })"
        ><i class="el-icon-folder-opened el-icon--left"></i>{{ $t('notFound.action') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style lang="scss" scoped>
$c: '.pageNotFound';

#{$c} {
  background-color: #f5f5f5;
  height: 100vh;
  position: relative;

  &__background {
    height: 100%;
    width: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  &__form {
    display: flex;
    align-items: center;
    background-color: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(154, 147, 140, 0.35);
    position: absolute;
    height: 422px;
    top: calc((100vh - 422px) / 2);
    width: 100%;

    div {
      padding-left: 20px;
      @include respond-above(sm) {
        padding-left: 0;
      }
    }

    @include respond-above(xs) {
      max-width: 540px;
      left: calc((100% - 540px) / 2);
    }

    @include respond-above(sm) {
      padding-left: 200px;
      border-radius: 21px;
      left: calc((100% - 540px - 200px) / 2);
    }

    h1 {
      font-size: 30px;
      margin-bottom: 20px;
      padding-right: 20px;
      @include respond-above(sm) {
        font-size: 46px;
      }
    }
  }

  &__logo {
    height: 64px;
    width: auto;
    padding: 30px;
    position: absolute;
    top: 0;
    left: 0;
    @include respond-above(sm) {
      height: 115px;
    }
  }

  &__img {
    display: none;
    position: absolute;
    top: calc((100% - 250px) / 2);
    left: 0;
    height: 250px;
    @include respond-above(sm) {
      display: block;
    }
  }
}
</style>
